import { render, staticRenderFns } from "./RoutingStatusDisplay.vue?vue&type=template&id=4afffb5e"
import script from "./RoutingStatusDisplay.vue?vue&type=script&lang=js"
export * from "./RoutingStatusDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports